import { housingTypeOptions, statesOptions } from 'constants/options';

import { CONTACT_INFORMATION_GROUP_ID } from './PersonalInfo.config';

// Split the rendered config around the Contact Information group so the CRM
// Contact card can be placed in normal flow ABOVE it: everything before that
// group renders first, then the CRM card, then the Contact Information / Email
// section. setEntityConfig still receives the full config for validation/save.
// Matched on the stable groupId (not the display title) so retitling/localizing
// can't break the split. If the group isn't present, lowerConfig is null and the
// caller skips the second FormGenerator (no empty gap box).
export const splitConfigAtContactInformation = config => {
  const groups = config?.groups ?? [];
  const splitIndex = groups.findIndex(group => group.groupId === CONTACT_INFORMATION_GROUP_ID);

  if (splitIndex === -1) {
    return { upperConfig: { groups }, lowerConfig: null };
  }

  return {
    upperConfig: { groups: groups.slice(0, splitIndex) },
    lowerConfig: { groups: groups.slice(splitIndex) },
  };
};

export const normalizeCurrentResidence = (currentResidence, counties) => {
  if (!currentResidence) {
    return {};
  }

  return {
    ...currentResidence,
    housingType: housingTypeOptions.find(opt => opt.value === currentResidence.housingType),
    state: statesOptions.find(opt => opt.value === currentResidence.state),
    county: counties[currentResidence.state]?.find(({ value }) =>
      value.toLowerCase().startsWith(currentResidence.county?.toLowerCase()),
    ),
  };
};
